import {createIcon, Svg} from "@gluestack-ui/icon";
import {Path} from "react-native-svg";

const IntestineIcon = createIcon({
  Root: Svg,
  viewBox: "0 0 35 37",
  path: (
    <>
      <Path
        d="M12.5957 8.90947H22.0124H18.4144C16.9479 8.90947 15.7597 7.72125 15.7597 6.25476V1.37109"
        stroke="#AEBFFC"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"/>
      <Path
        d="M8.8191 8.91211H7.38879C4.08848 8.91211 1.34473 11.2552 1.34473 14.5527C1.34473 17.853 4.01892 20.9223 7.31922 20.9223H24.7724"
        stroke="#AEBFFC"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"/>
      <Path
        d="M13.5022 35.7012V32.4955C13.5022 30.9539 12.2527 29.7044 10.7111 29.7044C8.28735 29.7044 6.32275 27.7398 6.32275 25.3161C6.32275 22.8923 8.28735 20.9277 10.7111 20.9277H23.6897"
        stroke="#AEBFFC"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"/>
      <Path
        d="M19.5686 35.7027V30.2542C19.5686 28.5178 18.4416 27.1125 16.7052 27.1125H14.223H27.4743C30.8887 27.1125 33.6575 24.3437 33.6575 20.9293C33.6575 17.5149 30.8887 14.7461 27.4743 14.7461H6.35352"
        stroke="#AEBFFC"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"/>
      <Path
        d="M20.9107 1.37109V3.37187C20.9107 4.7827 22.0544 5.9264 23.4653 5.9264C25.7916 5.9264 27.6811 7.81308 27.6811 10.1422V10.5346C27.6811 12.8609 25.7944 14.7504 23.4653 14.7504H20.0063"
        stroke="#AEBFFC"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  )
})

export { IntestineIcon };
